export function renderMetaTagsToString(data) {
    return data
        .map(function (tag) {
        if (tag.tag === 'title') {
            return "<title>" + tag.content + "</title>";
        }
        var serializedAttrs = [];
        for (var key in tag.attributes) {
            if (Object.prototype.hasOwnProperty.call(tag.attributes, key)) {
                serializedAttrs.push(key + "=\"" + tag.attributes[key] + "\"");
            }
        }
        return "<" + tag.tag + " " + serializedAttrs.join(' ') + " />";
    })
        .join('\n');
}
;
//# sourceMappingURL=renderMetaTagsToString.js.map